<template>
  <div class="page-container appstore_wrap">
    <div>
      <div class="section rights-require-wrap bgf">
        <div class="w1200">
          <div class="hd">
            <h2>填写商店信息</h2>
            <p>
              您可通过填写以下信息申请试用，我们会在1-3个工作日内处理。审核通过后，您将可以体验应用商店全部功能。咨询电话：18800156151
            </p>
          </div>
          <div class="bd">
            <div class="tabs-wrap">
              <div class="tab-content">
                <div class="panel-box">
                  <el-form
                    ref="form"
                    :model="registerInfo"
                    label-width="120px"
                    :rules="rules"
                  >
                    <el-divider>商店信息</el-divider>
                    <el-row>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="marketName" label="商店名称">
                          <el-input
                            placeholder="请输入商店名称"
                            v-model="registerInfo.marketName"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="domain" label="商店域">
                          <el-input
                            v-model="registerInfo.domain"
                            placeholder="商店域必须由独立的英文字母组成"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="description" label="商店简介">
                          <el-input
                            type="textarea"
                            placeholder="请输入商店简介"
                            v-model="registerInfo.description"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="logo" label="商店LOGO">
                          <el-upload
                            v-loading="uplogoImageLoading"
                            class="avatar-uploader marketlog"
                            :action="uploadConfig.api"
                            :with-credentials="true"
                            :headers="uploadConfig.headers"
                            :show-file-list="false"
                            :on-success="handleLogoAvatarSuccess"
                            :on-error="handleAvatarError"
                            :before-upload="beforeLogoAvatarUpload"
                          >
                            <el-avatar
                              v-loading="uplogoImageLoading"
                              class="logoImage"
                              v-if="registerInfo.logo"
                              shape="square"
                              fit="fill"
                              :src="registerInfo.logo"
                            ></el-avatar>
                            <i
                              v-else
                              class="el-icon-plus avatar-uploader-icon"
                            ></i>
                          </el-upload>
                          <span style="color: #999999; font-size: 12px">
                            请上传 150*50 规格的PNG图片
                          </span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <!-- <el-divider>企业实名信息</el-divider>
                    <el-row>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="ename" label="企业名称">
                          <el-input clearable placeholder="请输入企业名称" v-model="registerInfo.ename"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="corporate" label="企业法人">
                          <el-input placeholder="请输入企业法人" v-model="registerInfo.corporate"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="socialCode" label="社会信用代码">
                          <el-input placeholder="请输入社会信用代码" v-model="registerInfo.socialCode"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row> -->
                    <el-divider>管理员信息</el-divider>
                    <el-row>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="ename" label="企业名称">
                          <el-input
                            clearable
                            placeholder="请输入企业名称"
                            v-model="registerInfo.ename"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="realName" label="姓名">
                          <el-input
                            placeholder="请输入姓名"
                            v-model="registerInfo.realName"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <div style="display: flex">
                          <el-form-item
                            label="手机号"
                            prop="phone"
                            style="display: inline-block"
                          >
                            <el-input
                              style="width: 160px; margin-right: 8px"
                              v-model="registerInfo.phone"
                              placeholder="请输入您的手机号"
                              clearable
                            ></el-input>
                          </el-form-item>
                          <el-button
                            style="
                              width: 120px;
                              height: 40px;
                              margin-right: 8px;
                              margin-top: 2px;
                            "
                            class="btns"
                            @click="detection('phone')"
                            >{{ content }}</el-button
                          >
                          <el-form-item
                            label-width="0px"
                            prop="phoneCode"
                            style="width: 100px; display: inline-block"
                            :error="errorVerificationMsg"
                          >
                            <el-input
                              style="width: 100px"
                              placeholder="验证码"
                              auto-complete="new-password"
                              v-model="registerInfo.phoneCode"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="email" label="邮箱">
                          <el-input
                            placeholder="请输入邮箱"
                            v-model="registerInfo.email"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col class="formitem" :span="12">
                        <el-form-item prop="password" label="密码">
                          <el-input
                            type="password"
                            auto-complete="new-password"
                            v-model="registerInfo.password"
                            placeholder="请输入密码"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row style="text-align: center">
                      <el-button
                        type="primary"
                        v-loading="Loading"
                        @click="handleStoreInfo"
                        >提交</el-button
                      >
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DialogVerificationCode
      v-if="dialogVisible"
      @handleClose="handleClose"
      @countDown="countDown"
      :dialogVisible="dialogVisible"
      :phone="this.registerInfo.phone"
    />
  </div>
</template>

<script>
import DialogVerificationCode from '@/components/Dialog/VerificationCode/index.vue';
import { getToken } from '@/utils/auth';
import { errorHandle } from '@/utils/error';
import {
  validateEmpty,
  validateEnterpriseName,
  validateRegistered
} from '@/utils/validate';

export default {
  name: 'Authenticate',
  components: {
    DialogVerificationCode
  },
  data() {
    const validateMobileEname = (rule, value, callback) => {
      if (!validateEmpty(value)) {
        callback(new Error('请输入企业名称'));
      } else if ((value && value.length < 3) || value.length > 32) {
        callback(new Error('企业名称必须在 3 到 32 个字符之间'));
      } else if (validateEmpty(value)) {
        if (!validateEnterpriseName(value)) {
          callback(
            new Error(
              '允许数字、字母、中文、_、-组合,需数字或字母开头,不允许_、-、结尾'
            )
          );
        } else {
          const obj = {};
          obj.ename = value || undefined;
          this.$store
            .dispatch('checkEname', obj)
            .then(() => {
              callback();
            })
            .catch((err) => {
              if (err.code == 1001) {
                callback('企业名称已存在');
              }
            });
        }
      }
    };
    const validateDomain = (rule, value, callback) => {
      const regExp = /^[a-zA-Z]*$/g;
      if (!validateEmpty(value)) {
        callback(new Error('请输入企业域'));
      } else if (value && (value.length < 4 || value.length > 32)) {
        callback(new Error('企业域只能由4-32位'));
      } else if (!regExp.test(value)) {
        callback(new Error('企业域只能由4-32位英文字母组成'));
      } else {
        const obj = {};
        obj.domain = value || undefined;
        this.$store
          .dispatch('checkDomain', obj)
          .then(() => {
            callback();
          })
          .catch(() => {
            callback('企业域名已存在或不符合规范，企业域由4-32位英文字母组成');
          });
      }
    };
    const validateMobilePhone = (rule, value, callback) => {
      const reg = /^1[3456789]\d{9}$/;
      if (value === '' || value == undefined) {
        callback(new Error('请输入手机号码'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入有效的手机号码'));
      } else {
        this.$store
          .dispatch('checkPhone', { phone: value })
          .then(() => {
            callback();
          })
          .catch((err) => {
            if (err && err.code) {
              validateRegistered(err.code, (msg) => {
                callback(msg);
              });
            }
          });
      }
    };
    const validateEmail = (rule, value, callback) => {
      const reg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
      if (value === '' || value == undefined) {
        callback(new Error('请输入企业邮箱'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入有效的企业邮箱'));
      } else {
        this.$store
          .dispatch('checkEmail', { email: value })
          .then(() => {
            callback();
          })
          .catch((err) => {
            if (err && err.code) {
              validateRegistered(err.code, (msg) => {
                callback(msg);
              });
            }
          });
      }
    };
    const validateMarket = (rule, value, callback) => {
      if (value === '' || value == undefined) {
        callback(new Error('请输入商店名称'));
      } else if (value && (value.length < 2 || value.length > 255)) {
        callback(new Error('商店名称字符在2-255之间'));
      } else {
        this.$store
          .dispatch('checkMaktet', { name: value })
          .then(() => {
            callback();
          })
          .catch((err) => {
            if (err && err.code) {
              // errorHandle(err)
              validateRegistered(err.code, (msg) => {
                callback(msg);
              });
            }
          });
      }
    };

    let baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      Loading: false,
      dialogVisible: false,
      disabled: true,
      content: '获取验证码',
      totalTime: 60,
      errorPhoneMsg: null,
      errorVerificationMsg: null,
      registerInfo: {
        domain: '',
        email: '',
        ename: '',
        password: '',
        phone: '',
        phoneCode: '',
        realName: '',
        address: '',
        corporate: '',
        description: '',
        licenseImagePath: [],
        logo: '',
        marketName: '',
        socialCode: ''
      },
      uploadImageLoading: false,
      uplogoImageLoading: false,
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      rules: {
        phoneCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '请输入正确验证码',
            trigger: 'blur'
          }
        ],
        socialCode: [
          { required: true, message: '社会信用代码是必填', trigger: 'blur' },
          {
            min: 18,
            max: 18,
            message: '社会信用代码只能是18位',
            trigger: 'blur'
          }
        ],
        corporate: [
          { required: true, message: '企业法人是必填', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '企业法人长度应该最小两个字符',
            trigger: 'blur'
          }
        ],
        licenseImagePath: [
          { required: true, message: '必须上传营业执照', trigger: 'blur' }
        ],
        ename: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobileEname
          }
        ],
        domain: [
          {
            required: true,
            validator: validateDomain,
            trigger: 'blur'
          }
        ],
        realName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 16,
            message: '姓名长度在2-16位',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobilePhone
          }
        ],
        email: [
          {
            required: true,
            trigger: 'blur',
            validator: validateEmail
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 255,
            message: '密码长度在6-255位',
            trigger: 'blur'
          }
        ],
        // logo: [
        //   {
        //     required: true,
        //     message: '请上传商店LOGO',
        //     trigger: 'blur'
        //   }
        // ],
        address: [
          {
            required: true,
            min: 2,
            max: 255,
            message: '联系地址字符在2-255之间',
            trigger: 'blur'
          }
        ],
        marketName: [
          {
            required: true,
            validator: validateMarket,
            trigger: 'blur'
          }
        ],
        description: [
          { required: true, message: '请输入商店简介', trigger: 'blur' },
          {
            max: 255,
            message: '商店简介字符数在255以内',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    detection(value) {
      this.$refs.form.validateField(value, (moneyError) => {
        if (!moneyError) {
          this.handleVerification();
        }
      });
    },
    handleVerification() {
      this.dialogVisible = null;
      this.$refs.form.validateField('phone', (moneyError) => {
        if (!moneyError) {
          if (!this.disabled) return; // 改动的是这两行代码
          this.dialogVisible = true;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    countDown() {
      if (!this.disabled) return; // 改动的是这两行代码
      this.disabled = false;
      this.dialogVisible = false;
      this.content = this.totalTime + 's';
      const _th = this;
      const clock = window.setInterval(() => {
        _th.totalTime--;
        _th.content = _th.totalTime + 's';

        if (_th.totalTime < 0) {
          window.clearInterval(clock);
          _th.content = '发送验证码';
          _th.totalTime = 60;
          _th.disabled = true; // 这里重新开启
        }
      }, 1000);
    },
    handleStoreInfo() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.Loading = true;
          const data = Object.assign(
            {},
            { EntRegisterReq: this.registerInfo },
            this.registerInfo
          );
          this.$store
            .dispatch('RegisterStores', data)
            .then((res) => {
              this.$emit('next', this.registerInfo);
              this.Loading = false;
            })
            .catch((err) => {
              this.Loading = false;
              errorHandle(err);
            });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.registerInfo.licenseImagePath = [res.FileURL];
      this.uploadImageLoading = false;
    },
    handleLogoAvatarSuccess(res, file) {
      this.registerInfo.logo = res.FileURL;
      this.uplogoImageLoading = false;
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.error(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.error('上传失败!');
      this.uploadImageLoading = false;
      this.uplogoImageLoading = false;
    },
    detectionImage(file, loadingName) {
      if (!file) {
        return false;
      }
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error('上传头像图片只能是 JPG、PNG格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }

      const canUpload = (isJPG || isPng) && isLt2M;
      if (canUpload && loadingName) {
        this[loadingName] = true;
      }
      return canUpload;
    },
    beforeAvatarUpload(file) {
      return this.detectionImage(file, 'uploadImageLoading');
    },
    beforeLogoAvatarUpload(file) {
      return this.detectionImage(file, 'uplogoImageLoading');
    },
    beforeAvatarUploadpic(file) {
      return this.detectionImage(file);
    }
  },

  created() {},
  computed: {
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    }
  }
};
</script>

<style lang="scss" scoped>
ol,
ul,
dl {
  margin: 0;
}
.dn-btn {
  margin: 0;
  height: 32px;
  padding: 0 24px;
  font-size: 12px;
  line-height: 30px;
  border-width: 1px;
}

.bgf {
  background: #fff;
}
.rights-require-wrap {
  padding-top: 120px;
  .tabs-wrap {
    margin: 0 10px;
    .tab-nav {
      width: 205px;
      margin: 0 auto 50px;
      *zoom: 1;
      &:before {
        content: '';
        display: table;
      }
      .active {
        color: #fff;
        background: #409eff;
        border-color: #409eff;
        z-index: 2;
      }
      a {
        position: relative;
        float: left;
        line-height: 36px;
        width: 100px;
        text-align: center;
        text-decoration: none;
        font-size: 14px;
        color: #373d41;
        background: #fff;
        border: 1px solid #d7d8d9;
      }
    }
  }

  .panel-box {
    background: #fff;
    border: 1px solid #d7d8d9;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    padding: 30px 0;
    .more-info-btn {
      display: none;
      padding: 20px 0;
      font-size: 14px;
      color: #409eff;
      text-align: center;
      cursor: pointer;
    }
  }
  .hidden {
    display: none;
  }
}
.section {
  padding: 80px 0;
  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }
  .hd {
    margin-bottom: 40px;
    text-align: center;
    h2 {
      font-size: 24px;
      color: #373d41;
    }
  }
  .bd {
    position: relative;
    *zoom: 1;
    &:before {
      content: '';
      display: table;
    }
    &:after {
      clear: both;
    }
  }
}
.plan-box {
  position: relative;
  margin: 0 10px;
  background: #fff;
  border: 1px solid #d7d8d9;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
  .item {
    &:hover {
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    }
    border-bottom: 1px solid #d5d5d6;
    .active {
      background: #409eff;
      h3,
      p {
        color: #fff;
      }
      .join-btn {
        color: #fff;
        background-color: transparent;
        border: 1px solid #fff;
      }
    }
    dt {
      position: relative;
      height: 96px;
      cursor: pointer;
      h3 {
        font-size: 18px;
        color: #373d41;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 0;
      }
      p {
        font-size: 14px;
        color: #606468;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .head-info {
        padding: 25px 200px 0 100px;
      }
      .join-btn {
        position: absolute;
        right: 40px;
        top: 30px;
        border: 1px solid #409eff;
        color: #409eff;
        &:hover {
          color: #fff;
          background: #409eff;
          border-color: #409eff;
        }
      }
      .icon {
        position: absolute;
        left: 25px;
        top: 23px;
        width: 50px;
      }
      .def {
        display: block;
      }
      .hover {
        display: none;
      }
    }
    dd {
      padding: 30px 100px;
      background: #f5f5f6;
      .intr {
        margin-bottom: 5px;
        font-size: 14px;
        color: #606468;
      }
      .more {
        margin-bottom: 20px;
      }
      span {
        font-weight: 700;
        font-size: 14px;
        color: #5f6367;
      }
      li {
        font-size: 14px;
        color: #606468;
        line-height: 24px;
      }
    }
  }
}
.formitem {
  padding-left: 16px;
  padding-right: 16px;
}
.marketlog {
  width: 150px;
  border: 1px solid #cccccc;
  text-align: center;
  height: 50px;
  .el-upload {
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/registinfo.vue